import React, { useState,useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { var_api } from '../constant.js';
import "./currency_master.css";

function CurrencyMaster(){
    const history = useHistory();
    const shopName= localStorage.getItem('shopName');
    const [currency_name,setCurrency_name] = useState("");
    const [currency_description,setCurrency_description] =  useState("");
    const [currencys, setCurrencys] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ searchQuery,setSearchQuery] = useState('');

    //redirect to home page
    const handleHome = () =>{
      history.push('/AdminDashboard')
    }

    //list the catgories in select
    useEffect(() => {
        fetchCURRENCYs();
    
    }, []);


//fetch the uom details
    const fetchCURRENCYs = async () => {
        setLoading(true);

        const shopId = localStorage.getItem('shopId');
       try {
        const response = await axios.get(`${var_api}/api/currency-master/get-currency` );
        const use = response.data
      setCurrencys(use);
      
      console.log("categories",currencys)
      setLoading(false);
      }catch (error) {
        console.log('Error fetching data:', error);
        
        }
      };

 

   //post the form data
    const Submit = async (e) => {
      e.preventDefault();
    
      try {
        const response = await axios.post(`${var_api}/api/currency-master/post`, {
            currency_name: currency_name.trim().toUpperCase(), 
            currency_description: currency_description
        });
        console.log("response",response)
    
        if (response.status === 200) {
          Swal.fire({
            icon:"success",
            text:`Currency Created Successfully`,
            confirmButtonColor:"#007500"
          })
          setCurrency_description(" ");
          setCurrency_name(" ");
          fetchCURRENCYs();
          console.log('Data inserted successfully.')

      }

      } catch (error) {
        
        Swal.fire({
            icon:"error",
            text:`${error.response.data.error}`.toUpperCase(),
            confirmButtonColor:"#007500"
          })
        console.error('Error:',error);
        // Handle error scenario as needed
      }
    };

    const handleToReset = () => {
        setCurrency_description(" ");
        setCurrency_name(" "); 
    }



      //get the value in search and set the setstate
      const handleSearchInput = (e) => {
        setSearchQuery(e.target.value)
        };


         //search the transaction data
      const filteredUoms = currencys.filter((order) => {
        const searchLower = searchQuery.toLowerCase();
        return (
          (order.currency_name && order.currency_name.toString().toLowerCase().includes(searchLower)) ||
          (order.currency_description && order.currency_description.toString().toLowerCase().includes(searchLower))
          
        );
      });

      //to open the form for slot updation 
    const handleEditCurrency = async (data) => {
        const { value: formValues } = await Swal.fire({
            title: 'Update Currrency',
            html: `
             <label class="swalLa">Name</label>
             <br/>
              <input id="swal-input1" class="swal2-input fin" name="currency_name" placeholder="Currency Name" value="${data.currency_name || ''}">
              <br/>
              <br/>
              <label class="swalLa">Description</label>
              <input id="swal-input2" class="swal2-input fin" name="currency_description" placeholder="Currency Description" value="${data.currency_description || ''}">
             
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#007500',
            confirmButtonText: 'Submit',
            preConfirm: () => {
              return new Promise(async (resolve) => {
                const input1 = document.getElementById('swal-input1').value;
                const input2 = document.getElementById('swal-input2').value;
        
                if (!input1 || !input2) {
                  Swal.showValidationMessage('Please fill in all the required fields');
                  resolve(null);
                } else {

                  const requestData = {
                    currency_name: input1.trim().toUpperCase() || data.currency_name.trim().toUpperCase(),
                    currency_description: input2 || data.currency_description
                  };
        
                  try {
                    // Make a PUT request to update the UOM
                    const response = await axios.put(`${var_api}/api/currency-master/put/${data.id}`, requestData, {
                      headers: {
                        'Content-Type': ' application/json', 
                      },
                    });
        
                    if (response.status === 200) {
                        fetchCURRENCYs();
                      // Category updated successfully
                      Swal.fire({
                        icon: 'success',
                        text: 'Currency updated successfully',
                        confirmButtonColor: '#007500',
                      });
                    } else {
                      Swal.fire({
                        icon: 'error',
                        text: 'Failed to update Currency',
                        confirmButtonColor: '#007500',
                      });
                    }
                  } catch (error) {
                    console.error('Error updating category:', error);
                    Swal.fire('Error', 'Failed to update category. Please try again.', 'error');
                  }
        
                  resolve(requestData);
                }
              });
            },
          });
      };


       //delete method for remove UOM
     const handleDeleteCurrency = (id) => {
        axios
        .delete(`${var_api}/api/currency-master/currency-delete/${id}`)
        .then((response) => {
          if (response.status === 200) {
            console.log(id)
            fetchCURRENCYs();
            Swal.fire("success"," Currecny Removed Successfully!","success")
            // Perform any other actions you need on success
          } else if (response.status === 404) {
            console.log('Currecny not found');
            Swal.fire("error","Currecny not found!","error")
          }
        })
        .catch((error) => {
          console.error('Error executing the request:', error);
          Swal.fire("error","Failed to Remove Currecny!","error")
          // Handle the error as needed
        });
      }


    return(
        <>
        <nav className="navbar navbar-expand navbar-light py-2 sticky-top" style={{boxShadow: "0px 0px 1px 0px black",backgroundColor:"green",border:"none"}} >
          <h5 className="hefou" style={{textAlign:"center",color:"white",paddingLeft:"5px"}}><i class="bi bi-arrow-left-circle" onClick={handleHome} style={{fontSize:"21px"}}></i>{' '}Currency MASTER</h5>
        </nav>
        <div id='dailybacku'>
          <br/>
          <br/>
          <div id='fiboxu'>
            <form onSubmit={Submit}>
            <div class="labelsu">
            <lable style={{color:"green",fontWeight:"bold",fontSize:"18px",letterSpacing:"2px"}}>Currency Name  </lable>
            <input  className="form-inputu" type='text' name='currency_name'
             required
             value={currency_name}
             onChange={(e) => setCurrency_name(e.target.value)}/>
            </div>
            <br/>
            <div class="labelsu">
            <lable style={{color:"green",fontWeight:"bold",fontSize:"18px",letterSpacing:"2px"}}>Currency Description</lable>
            <input  className="form-input1u" type='text' name='currency_description'
            required
             value={currency_description}
             onChange={(e) => setCurrency_description(e.target.value)}/>
            </div>
            <br/>
            <br/>
            <button className='btn btn-success' id='dasubu'>Submit</button> {' '}
            
            </form>
            <button className='btn btn-danger' style={{borderRadius: "11px", marginLeft:"540px", marginTop:"-63px"}} onClick={handleToReset}> Reset</button>
          </div>
          <br/>
          <div id='taboxu'>
          <table class="table table-responsive-sm table-hover" style={{maxWidth:"90%",backgroundColor:"rgba(10, 241, 33, 0.133)"}}>
            <caption className="hefou" style={{captionSide:"top",textAlign:"right",fontSize:"25px",color:"black",fontWeight:"bolder"}}>
            <input type='Search' name='search' className='listSearchu' placeholder='Search Currency' onChange={handleSearchInput}  value={searchQuery}/>
            </caption>
  <thead>
    <tr>
      <th scope="col">S.No</th>
      <th scope="col">Currency Name</th>
      <th scope="col">Description</th>
      <th scope="col">Action</th>
      <th></th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : (
  <tbody >
   {filteredUoms.length > 0 ? (
   filteredUoms.map((data, index) => (
  
    <tr key={index}>
      <th scope="row">{index + 1}</th>
      <td style={{textTransform:"uppercase", fontSize:"15px"}}>{data.currency_name}</td>
      <td style={{textTransform:"capitalize",fontSize:"15px"}}>{data.currency_description}</td>
      <td>
      <i class="bi bi-pencil-square" onClick={() => handleEditCurrency(data)}  style={{fontSize:"20px",color:"rgb(9, 97, 9)"}}></i>{' '}
      <i class="bi bi-trash" onClick={() => handleDeleteCurrency(data.id)}  style={{fontSize:"21px",color:"rgb(175, 2, 2)"}}></i>
      </td>
    </tr>
  
)) 
): (
    <tr>
      <td colSpan="7" style={{ textAlign: "center" }}>
        No Data Available
      </td>
    </tr>
   )
}

   </tbody>
  )}
</table>
          </div>
        </div>
        </>
    )
}

export default CurrencyMaster;